export default "__VITE_ASSET__2y2b12MX__"